(function() {
    initSliders();

    function initSliders() {
        if(typeof Swiper === 'undefined') {
            return setTimeout(initSliders, 200);
        }

        const sliders = document.querySelectorAll('.three-images.swiper');

        if(!sliders.length) {
            return;
        }

        sliders.forEach(slider => {
            if (slider.swiper && slider.swiper.initialized) {
                return;
            }

            const slides = slider.querySelectorAll('.swiper-slide');

            if(!slides.length) {
                return;
            }

            slider.swiper = new Swiper(slider, {
                centeredSlides: false,
                loop: false,
                draggable: true,
                slidesPerView: 'auto',
                spaceBetween: 10,
            });
        })
    }
})();